
import styles from './styles.module.css'
import AnchorLink from '../AnchorLink';
import { FaArrowRightLong } from 'react-icons/fa6';

const Card = () => {

    return (
        <article className='col-12 col-md-6 col-xl-4 mb-4'>
            <div className={styles['blog-article']}>
                <div className={styles['image']}>
                    <img 
                        alt='Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
                        src={'https://placehold.co/500x300/jpg'}
                        width={0}
                        height={0}
                        sizes="100vw"
                        style={{ width: '100%', height: 'auto' }}
                    />
                </div>
                <div className={`${styles['content']}`}>
                    <div className="mb-2 d-flex align-items-center">
                        <time dateTime="2023-05-17T21:26:34+10:00">17 May 2023</time>
                    </div>
                    <h3>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum in, soluta voluptas iure similique tempore quaerat sed corrupti porro enim ipsa aliquid, ullam inventore neque harum optio commodi corporis totam.</p>

                    <div className='mt-4'>
                        <AnchorLink 
                            className='mt-4'
                            icon={<FaArrowRightLong className='ms-2' size={20}/>}
                            iconPostion='right'
                            title={'Continue Reading '}                        
                            href={'#!'}
                            target='_blank'
                        />
                    </div>
                </div>
            </div>
        </article>
    );
};

export default Card;